import { getAuthRole, getAuthUserId } from "./authSession";

/** Employees who may list/view all timesheets (admin-style dashboard) while keeping employee role elsewhere. */
export const TIMESHEET_ADMIN_VIEW_EMPLOYEE_IDS = [
  "19d4def0-d7b4-498b-9d2a-7f8c5efc649c",
  "e92cd405-d06f-481b-bac7-93a580f774c9",
];

export function getLoggedInUserId() {
  return getAuthUserId() || (localStorage.getItem("user_id") || "").trim();
}

export function getUserRole() {
  return getAuthRole();
}

export function isTimesheetAdminViewEmployee(userId = getLoggedInUserId()) {
  return TIMESHEET_ADMIN_VIEW_EMPLOYEE_IDS.includes(String(userId || "").trim());
}

/** Full admin timesheet dashboard (all employees, approve/reject, no manager scoping). */
export function hasTimesheetAdminDashboardAccess(userId = getLoggedInUserId()) {
  return getUserRole() === "admin" || isTimesheetAdminViewEmployee(userId);
}

/**
 * Admin-style timesheet list: all employees' rows, employee filter, name column.
 */
export function canViewAllTimesheets() {
  if (hasTimesheetAdminDashboardAccess()) return true;
  if (getUserRole() === "manager") return true;
  return false;
}

/** Saved/draft rows (status 0) — not for admin or allowlisted admin-dashboard users. */
export function shouldIncludeSavedTimesheetsInList() {
  if (hasTimesheetAdminDashboardAccess()) return false;
  const role = getUserRole();
  return role === "employee" || role === "manager";
}
